import type { Config } from 'tailwindcss'

const config: Config = {
  content: ['./index.html', './src/**/*.{vue,js,ts,jsx,tsx}'],
  theme: {
    screens: {
      sm: '360px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      '2xl': '1536px',
      '3xl': '1750px',
    },
    fontSize: {
      // Manager
      xs: ['12px', '16px'],
      sm: ['14px', '18px'],
      base: ['16px', '22px'],
      lg: ['19px', '26px'],
      '2lg': ['24px', '28px'],
      xl: ['28px', '32px'],
      '2xl': [
        '36px',
        {
          lineHeight: '40px',
          fontWeight: '300',
        },
      ],
      // Customer
      c3xs: ['9px', '13px'],
      'c2.5xs': ['10px', '14px'],
      c2xs: ['11px', '16px'],
      cxs: ['12px', '16px'],
      c2sm: ['13px', '18px'],
      csm: ['14px', '18px'],
      cbase: ['16px', '22px'],
      c2base: ['18px', '22px'],
      c3base: ['19px', '26px'],
      clg: ['20px', '26px'],
      c2lg: ['22px', '28px'],
      c3lg: [
        '24px',
        {
          lineHeight: 'normal',
          fontWeight: '700',
        },
      ],
      cxl: [
        '28px',
        {
          lineHeight: '32px',
          fontWeight: '900',
        },
      ],
      c2xl: [
        '34px',
        {
          lineHeight: 'normal',
          fontWeight: '700',
        },
      ],
    },
    extend: {
      fontFamily: {
        sans: [
          'Lab Grotesque',
          'Helvetica',
          'ui-sans-serif',
          'system-ui',
          '-apple-system',
          'sans-serif',
        ],
      },
      colors: {
        mbg: '#ededed',
        mbg2: '#f8f8f8',
        mbg3: '#f1f1f1',
        mbrd: '#e1e1e1',
        mblack: '#000000',
        mblack1: '#1F1F1F',
        mgray: '#7a7a7a',
        mgray2: '#b7b7b7',
        mred: '#fe5d2a',
        cgreen: '#2EAA4D',
      },
      aspectRatio: {
        '0.7': '0.7',
      },
      animation: {
        'marquee-mobile': 'marquee-mobile 35s linear infinite',
        'marquee-desktop': 'marquee-desktop 65s linear infinite',
      },
      keyframes: {
        'marquee-mobile': {
          '0%': { transform: 'translateX(0)' },
          '100%': { transform: 'translateX(calc(-100% - 1rem))' },
        },
        'marquee-desktop': {
          '0%': { transform: 'translateX(0)' },
          '100%': { transform: 'translateX(calc(-100% - 1rem))' },
        },
      },
    },
  },
  plugins: [],
}
export default config
